import { palette } from './palette';
import headerBg from 'assets/images/header-bg.webp';
import testimonialBg from 'assets/images/testimonial-banner-img.webp';
import subscriptionSectionBg from 'assets/images/subscription-bg.webp';
import footerBg from 'assets/images/footer-bg.webp';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
  },

  '.gregS-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0
    },

    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: palette.text.highlight,
    },
    '& .MuiSwitch-thumb': {
      background: palette.background.thumb,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.header,

      '& .home-hero-pretitle': {
        paddingBottom: 32
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        maxWidth: 480,
        fontWeight: 'bold',
        color: palette.text.highlight
      },
      '& .home-hero-subtitle': {
        maxWidth: 520,
        color: palette.text.highlight
      },
      '& .login-button': {
        background: palette.text.highlight,
        color: palette.secondary.main,
        borderColor: palette.secondary.main
      }
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',
        '& .section-header__title': {
          fontSize: '2.5rem',
        },
        '& .definition-service-description': {
          fontSize: '1.125rem',
          lineHeight: '26px'
        },
        '@media screen and (max-width: 900px)': {
          '& .section-header__title': {
            fontSize: '2rem',
          },
        },
        '@media screen and (min-width: 900px)': {
          '& .section-header__title': {
            paddingBottom: 56,
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundImage: `url(${subscriptionSectionBg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .highlight-divider': {
            background: palette.text.border,
          },
          '&:hover': {
            background: palette.text.highlight,
            color: palette.text.primary,
          },
          '& .price-value': {
            color: palette.text.price
          },
          '& .price-frequency, .display-frequency': {
            color: palette.text.light
          },
          '& .maxAgeDisclaimer': {
            paddingBottom: 16
          },
          '& .customcardTitle': {
            color: palette.text.dark,
            fontWeight: 400,
            fontSize: 22,
          }
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
        },

        '& .subscription-section': {
          '& .section-header__title, & .section-header__subtitle, & .subscription-tabs-label, & .summary-text, & .summary-subtext':
          {
            color: palette.text.highlight,
          },

          '@media(min-width: 900px)': {
            marginTop: 10
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.background.step,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .step-counter': {
        backgroundColor: palette.background.step,
        color: palette.text.primary,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`
        },
        '& .savings-header': {
          color: palette.text.primary
        }
      },
      '& .savings-contact-card': {
        background: palette.background.footer,
        '& .faq-contact-section': {
          padding: '48px 0px',
          '& .contact-img-wrapper': {
            width: '64px',
            maxWidth: '64px',
          },
          '& .contact-card-title, & .contact-card-subtitle':
          {
            color: palette.text.primary,
          },
          '& .provider-contact-details, & .provider-contact-link': {
            color: palette.text.secondary
          }
        },
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .faq-hero-section, & .checkout-hero-section':
    {
      backgroundImage: `url(${headerBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      '& .hero-header-title, & .hero-header-subtitle': {
        color: `${palette.text.highlight} !important`,
      },
      background: palette.background.header,
    },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title, .hero-static-subtitle': {
        color: palette.text.highlight
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        color: palette.text.highlight
      },
      '& .section-header__title, .section-header__subtitle': {
        color: palette.text.primary
      },
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      backgroundImage: `url(${testimonialBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      background: palette.background.light,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .custom-avatar': {
        display: 'none',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.background.arrow,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0
            },
          }
        }
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
        color: palette.text.highlight
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0',
      },
      '& .section-header__title-wrapper, .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center'
      },
      '& .hero-link-button': {
        background: palette.primary.main,
        '&:hover': {
          backgroundColor: palette.secondary.main
        }
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.light,
      },
      '& .faq-link': {
        fontWeight: 500,
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title, & .contact-card-subtitle':
        {
          color: palette.text.primary,
        },
        '& .provider-contact-details, & .provider-contact-link': {
          color: palette.text.secondary
        }
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.text.primary,
        }
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .section-header__title, & .section-header__subtitle': {
          color: palette.text.highlight,
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.footer,
        },
        '& .primary-static-button': {
          background: palette.text.highlight,
          color: palette.text.primary
        }
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        color: palette.text.highlight
      }
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /*Dashboard - styles */
    '& .benefits-widget': {
      '& .MuiTableCell-head': {
        color: `${palette.text.highlight} !important`,
      },
    },

    /*Footer - styles */
    '& .footer-wrapper': {
      background: palette.background.main,
      color: palette.text.highlight,
      '& a': {
        color: palette.text.highlight,
        textDecoration: 'none',
      },
    }
  },
};